import { FC, ReactElement } from 'react'
import classNames from 'classnames'

import { Button, ButtonWithRefProps, Icon, IconName, PacoButtonLoadingSpinner } from '@/components'

import './SubmitButton.scss'

interface SubmitButtonProps extends ButtonWithRefProps {
    isLoading?: boolean
    icon?: IconName
    iconPos?: 'left' | 'right'
}

export const SubmitButton: FC<SubmitButtonProps> = ({
    isLoading,
    type = 'submit',
    text,
    icon,
    iconPos = 'left',
    disabled,
    className = '',
    ...submitButtonProps
}): ReactElement => {
    const submitButtonClassNames = classNames('submit-button', {
        [`submit-button--align-${iconPos}`]: iconPos,
    }, className)

    return (
        <Button
            {...submitButtonProps}
            type={type}
            text={text}
            disabled={isLoading || disabled}
            className={submitButtonClassNames}
        >
            {isLoading ? (
                <PacoButtonLoadingSpinner className="submit-button__icon" />
            ) : (
                icon && <Icon name={icon} className="submit-button__icon" />
            )}
            {text}
        </Button>
    )
}
